/*!

=========================================================
* Black Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useRef, useEffect, useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  Form,
  Input,
  FormGroup,
  Row,
  Col
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FileUploadContainer,
  FormField,
  UploadFileBtn,
  FilePreviewContainer,
  ImagePreview,
  PreviewContainer,
  PreviewList,
  FileMetaData,
  RemoveFileIcon
} from "../../../components/Styles/uploadAreaStyles";
import { normalizeCurrency, normalizeCalcCurrency } from "~/normalize";
import { store } from "~/store";
import api from "~/services/api";
import TagsInput from "~/components/Tags/TagsInput";
import history from "~/services/history";

export default function CotacaoCadastro(props) {
  // --------- colocando no modo claro do template
  document.body.classList.add("white-content");
  const fileInputField = useRef(null);

  const { id, rev } = useParams();
  const [isPackageOport, setIsPackageOport] = useState(false);
  const [tagsinput, settagsinput] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [auxState, setAuxState] = useState(false);
  const [disabledVlrProp, setDisabledVlrProp] = useState();
  const [oportData, setOportData] = useState({});
  const [cliRecDespData, setCliRecDespData] = useState({});
  const [parametrosData, setParametrosData] = useState({});
  const [cotacaoData, setCotacaoData] = useState({});
  const stateSchema = {
    empresaId: { value: "", error: "", message: "" },
    OportunidadeId: { value: "", error: "", message: "" },
    probVend: { value: "", error: "", message: "" },
    tipoCobranca: { value: "", error: "", message: "" },
    hrsPrevst: { value: "", error: "", message: "" },
    vlrProp: { value: "", error: "", message: "" },
    vlrDesc: { value: "", error: "", message: "" },
    vlrLiq: { value: "", error: "", message: "" },
    recLiq: { value: "", error: "", message: "" },
    prevLucro: { value: "", error: "", message: "" },
    numParcelas: { value: "", error: "", message: "" },
    motivo: { value: rev === "true" ? "2" : "1", error: "", message: "" }
  };
  const optionalSchema = {
    email: { value: "", error: "", message: "" },
    desc: { value: "", error: "", message: "" }
  };
  const [files, setFile] = useState([]);
  const [filesAux, setFileAux] = useState({});
  const [values, setValues] = useState(stateSchema);
  const [optional, setOptional] = useState(optionalSchema);

  useEffect(() => {
    const { empresa } = store.getState().auth;
    async function loadData() {
      const cotacaoResponse = await api.get(`/cotacao/${id}/?one=true`);
      if (cotacaoResponse.data === null || cotacaoResponse.data.length === 0) {
        const response = await api.get(`/empresa/${empresa}`);
        const oportResponse = await api.get(`/oportunidade/${id}`);
        const parametrosResponse = await api.get(`/parametros/?one=true`);
        const cliContResponse = await api.get(
          `/cliente/cont/${oportResponse.data.contato}/${oportResponse.data.contato}`
        );
        setIsPackageOport(
          oportResponse.data.RecDespId ===
            Number(process.env.REACT_APP_PACKAGE_RECIPE_ID)
        );
        settagsinput(oportResponse.data.Cliente.emailsCot.split(","));
        setOportData(oportResponse.data);
        setParametrosData(parametrosResponse.data);
        setValues(prevState => ({
          ...prevState,
          empresaId: { value: response.data.id },
          OportunidadeId: { value: oportResponse.data.id },
          email: { value: cliContResponse.data.email }
        }));
        setAuxState(true);
      } else {
        const oportResponse = await api.get(`/oportunidade/${id}`);
        const parametrosResponse = await api.get(`/parametros/?one=true`);
        const response5 = await api.get(
          `/cliente/cont/${oportResponse.data.contato}/${oportResponse.data.contato}`
        );
        setIsPackageOport(
          oportResponse.data.RecDespId ===
            Number(process.env.REACT_APP_PACKAGE_RECIPE_ID)
        );
        settagsinput(oportResponse.data.Cliente.emailsCot.split(";"));
        setOportData(oportResponse.data);
        setParametrosData(parametrosResponse.data);
        setCotacaoData(cotacaoResponse.data);
        setCotacaoData(prevState => ({ ...prevState }));
        setValues(prevState => ({
          ...prevState,
          empresaId: { value: cotacaoResponse.data[0].EmpresaId },
          OportunidadeId: { value: cotacaoResponse.data[0].OportunidadeId },
          probVend: { value: cotacaoResponse.data[0].probVend },
          tipoCobranca: { value: cotacaoResponse.data[0].tipoCobranca },
          hrsPrevst: { value: cotacaoResponse.data[0].hrsPrevst },
          vlrProp: {
            value: normalizeCalcCurrency(cotacaoResponse.data[0].vlrProp)
          },
          vlrDesc: {
            value: normalizeCurrency(cotacaoResponse.data[0].vlrDesc)
          },
          vlrLiq: {
            value: normalizeCalcCurrency(cotacaoResponse.data[0].vlrLiq)
          },
          recLiq: {
            value: normalizeCalcCurrency(cotacaoResponse.data[0].recLiq)
          },
          prevLucro: {
            value: normalizeCalcCurrency(cotacaoResponse.data[0].prevLucro)
          },
          numParcelas: { value: cotacaoResponse.data[0].numParcelas },
          email: { value: response5.data.email }
        }));
        setOptional(prevState => ({
          ...prevState,
          desc: { value: cotacaoResponse.data[0].desc }
        }));
      }
      setIsLoading(false);
    }
    loadData();
  }, [id]);

  var options = {};
  const notifyElment = useRef(null);
  function notify() {
    notifyElment.current.notificationAlert(options);
  }

  const convertBytesToKB = bytes => Math.round(bytes / 1000);
  const handleUploadBtnClick = () => {
    fileInputField.current.click();
  };

  const addNewFiles = newFiles => {
    // eslint-disable-next-line no-restricted-syntax
    for (const file of newFiles) {
      files.push(file);
      filesAux[file.name] = file;
    }
    return { ...filesAux };
  };
  const handleNewFileUpload = e => {
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      if (files.length < 2) {
        const updatedFiles = addNewFiles(newFiles);
        setFileAux(updatedFiles);
      } else {
        options = {
          place: "tr",
          message: (
            <div>
              <div>Ops! Você só pode anexar 2 arquivos em cada email</div>
            </div>
          ),
          type: "danger",
          icon: "tim-icons icon-alert-circle-exc",
          autoDismiss: 7
        };
        notify();
      }
    }
  };
  const removeFile = fileName => {
    setFile(files.filter(obj => obj.name !== fileName));
    delete filesAux[fileName];
    setFileAux({ ...filesAux });
  };

  function getCliData(cobranca) {
    if (!(cobranca === "2" || cobranca === 2)) {
      setDisabledVlrProp(true);
      api
        .get(
          `/cliente/rec_desp/${oportData.ClienteId}/?cobranca=${cobranca}&idRecDesp=${oportData.RecDespId}`
        )
        .then(result => {
          if (result.data === null) {
            options = {
              place: "tr",
              message: (
                <div>
                  <div>
                    Ops! Parece que não há uma receita cadastrada para este
                    cliente
                  </div>
                </div>
              ),
              type: "danger",
              icon: "tim-icons icon-alert-circle-exc",
              autoDismiss: 7
            };
            notify();
            setValues(prevState => ({
              ...prevState,
              vlrLiq: { value: "" },
              recLiq: { value: "" },
              prevLucro: { value: "" }
            }));
          } else {
            setCliRecDespData(result.data);
          }
        });
    } else {
      setDisabledVlrProp(false);
    }
  }

  if (!isLoading && !auxState) {
    getCliData(cotacaoData[0].tipoCobranca);
    setAuxState(true);
  }

  const verifyNumber = value => {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  };
  const handleChange = (event, name, type) => {
    event.persist();
    const target = event.target.value;
    switch (type) {
      case "number":
        if (verifyNumber(target)) {
          setValues(prevState => ({
            ...prevState,
            [name]: { value: target, error: "has-success" }
          }));
        } else {
          setValues(prevState => ({
            ...prevState,
            [name]: {
              value: target,
              error: "has-danger",
              message: "Insira um número válido"
            }
          }));
        }
        break;
      case "currency":
        setValues(prevState => ({
          ...prevState,
          [name]: { value: normalizeCalcCurrency(target) }
        }));
        break;
      case "optional":
        setOptional(prevState => ({
          ...prevState,
          [name]: { value: target }
        }));
        break;
      case "text":
        setValues(prevState => ({
          ...prevState,
          [name]: { value: target }
        }));
        break;
      default:
    }
  };

  const descontoChange = descont => {
    if (document.getElementsByName("tipoCobranca")[0].value === "2") {
      const imposto =
        (parametrosData.IRPJ +
          parametrosData.CSLL +
          parametrosData.COFINS +
          parametrosData.PIS +
          parametrosData.INSS +
          parametrosData.ISS) /
        10000;

      const value = descont.replace(/[.,]+/g, "");

      const hr = document.getElementsByName("hrsPrevst")[0].value;
      const prop = document
        .getElementsByName("vlrProp")[0]
        .value.replace(/[.,]+/g, "");
      const vLiq = prop - value;
      const rLiq = (
        (vLiq - parseFloat(parseFloat(vLiq)) * imposto) /
        100
      ).toFixed(2);
      const lucro = (
        parseFloat(rLiq) -
        (hr * parametrosData.vlrBsHr) / 100
      ).toFixed(2);

      setValues(prevState => ({
        ...prevState,
        vlrLiq: { value: normalizeCalcCurrency(vLiq) }
      }));
      setValues(prevState => ({
        ...prevState,
        recLiq: { value: normalizeCalcCurrency(rLiq) }
      }));
      setValues(prevState => ({
        ...prevState,
        prevLucro: { value: normalizeCalcCurrency(lucro) }
      }));
      return;
    }
    if (
      !(
        document.getElementsByName("tipoCobranca")[0].value === "2" &&
        cliRecDespData.valorRec
      )
    ) {
      const imposto =
        (parametrosData.IRPJ +
          parametrosData.CSLL +
          parametrosData.COFINS +
          parametrosData.PIS +
          parametrosData.INSS +
          parametrosData.ISS) /
        10000;

      const value = descont.replace(/[.,]+/g, "");

      const vHr = cliRecDespData.valorRec;
      const hr = document.getElementsByName("hrsPrevst")[0].value;
      const prop = hr * vHr;
      const vLiq = prop - value;
      const rLiq = (
        (vLiq - parseFloat(parseFloat(vLiq)) * imposto) /
        100
      ).toFixed(2);
      const lucro = (
        parseFloat(rLiq) -
        (hr * parametrosData.vlrBsHr) / 100
      ).toFixed(2);

      setValues(prevState => ({
        ...prevState,
        vlrLiq: { value: normalizeCalcCurrency(vLiq) }
      }));
      setValues(prevState => ({
        ...prevState,
        recLiq: { value: normalizeCalcCurrency(rLiq) }
      }));
      setValues(prevState => ({
        ...prevState,
        prevLucro: { value: normalizeCalcCurrency(lucro) }
      }));
    }
  };

  const handleTagsinput = value => {
    const verifyEmail = email => {
      var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailRex.test(email)) {
        return true;
      }
      return false;
    };

    if (!value.length) {
      settagsinput([]);
      return;
    }

    if (verifyEmail(value[value.length - 1])) {
      settagsinput(value);
    } else {
      options = {
        place: "tr",
        message: (
          <div>
            <div>Digite um email válido</div>
          </div>
        ),
        type: "danger",
        icon: "tim-icons icon-alert-circle-exc",
        autoDismiss: 7
      };
      notify();
    }
  };

  const handleSubmit = async evt => {
    evt.preventDefault();
    var aux = Object.entries(values);
    const tamanho = aux.length;

    for (let i = 0; i < tamanho; i++) {
      if (!(aux[i][1].error === "has-danger")) {
        var valid = true;
      } else {
        valid = false;
        break;
      }
    }
    for (let j = 0; j < tamanho; j++) {
      if (aux[j][1].value !== "") {
        var filled = true;
      } else {
        filled = false;
        setValues(prevState => ({
          ...prevState,
          [aux[j][0]]: { error: "has-danger", message: "Campo obrigatório" }
        }));
        break;
      }
    }

    if (valid && filled) {
      var vlrPropdb = values.vlrProp.value.replace(/[.,]+/g, "");
      var vlrDescdb = values.vlrDesc.value.replace(/[.,]+/g, "");
      var vlrLiqdb = values.vlrLiq.value.replace(/[.,]+/g, "");
      var recLiqdb = values.recLiq.value.replace(/[.,]+/g, "");
      var prevLucrodb = values.prevLucro.value.replace(/[.,]+/g, "");

      const formData = new FormData();

      // eslint-disable-next-line no-restricted-syntax
      for (const file of files) {
        formData.append("file", file);
      }
      const dataToSend = {
        EmpresaId: values.empresaId.value,
        OportunidadeId: values.OportunidadeId.value,
        probVend: values.probVend.value,
        tipoCobranca: values.tipoCobranca.value,
        hrsPrevst: values.hrsPrevst.value,
        vlrProp: vlrPropdb,
        vlrDesc: vlrDescdb,
        vlrLiq: vlrLiqdb,
        recLiq: recLiqdb,
        prevLucro: prevLucrodb,
        numParcelas: values.numParcelas.value,
        motivo: values.motivo.value,
        desc: optional.desc.value,
        isPackageOport
      };
      formData.append("body", JSON.stringify(dataToSend));
      // dispatch(
      //   oportUpdate(
      //     data1.id,
      //     data1.EmpresaId,
      //     data1.ColabId,
      //     data1.ClienteId,
      //     data1.UndNegId,
      //     data1.RecDespId,
      //     data1.SegmentoId,
      //     data1.RepresentanteId,
      //     data1.contato,
      //     data1.data,
      //     3,
      //     data1.cod,
      //     data1.desc,
      //     data1.narrativa
      //   )
      // );

      const delay = ms => new Promise(res => setTimeout(res, ms));
      await delay(500);

      // await api.post(`cotacao`, formData);

      if (values.motivo.value === "1") {
        await api
          .post(
            `/cotacao/?tipo=cotacao&situacao=orcamento&table=cotacao&Cc=${tagsinput.join(
              ","
            )}`,
            formData
          )
          .then(response => {
            if (response.data.emailSent === false) {
              toast.error(
                response.data.emailError ||
                  "Cotação salva, mas o e-mail não pôde ser enviado."
              );
            } else {
              toast.success("Cotação salva e e-mail enviado com sucesso.");
            }
            history.push("/tabelas/oportunidade/oport");
          })
          .catch(err => {
            toast.error(err.response.data.error);
          });
      } else {
        await api
          .post(
            `/cotacao/?tipo=cotacao&situacao=revisao&table=cotacao&Cc=${tagsinput.join(
              ","
            )}`,
            formData
          )
          .then(response => {
            if (response.data.emailSent === false) {
              toast.error(
                response.data.emailError ||
                  "Cotação salva, mas o e-mail não pôde ser enviado."
              );
            } else {
              toast.success("Cotação salva e e-mail enviado com sucesso.");
            }
            history.push("/tabelas/oportunidade/oport");
          })
          .catch(err => {
            toast.error(err.response.data.error);
          });
      }
    } else {
      options = {
        place: "tr",
        message: (
          <div>
            <div>Ops! Há algo errado</div>
          </div>
        ),
        type: "danger",
        icon: "tim-icons icon-alert-circle-exc",
        autoDismiss: 7
      };
      notify();
    }
  };
  return (
    <>
      {isLoading ? (
        <>
          <div className="content" />
        </>
      ) : (
        <>
          <div className="rna-container">
            <NotificationAlert ref={notifyElment} />
          </div>
          <div className="content">
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader>
                    <h3 style={{ marginBottom: 0 }}>Cotação</h3>
                    <p style={{ fontSize: 11 }}>
                      {oportData.cod} | {oportData.desc}
                    </p>
                    <p style={{ fontSize: 11 }}>{oportData.Cliente.nomeAbv}</p>
                  </CardHeader>
                  <CardBody>
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col md="4">
                          {" "}
                          <Label>Probabilidade de Venda</Label>
                          <FormGroup
                            className={`has-label ${values.probVend.error}`}
                          >
                            <Input
                              name="probVend"
                              type="select"
                              onChange={event =>
                                handleChange(event, "probVend", "text")
                              }
                              value={values.probVend.value}
                            >
                              <option disabled value="">
                                {" "}
                                Selecione a Probabilidade de venda{" "}
                              </option>
                              <option value={1}>Alta</option>
                              <option value={2}>Média</option>
                              <option value={3}>Baixa</option>
                            </Input>
                            {values.probVend.error === "has-danger" ? (
                              <Label className="error">
                                {values.probVend.message}
                              </Label>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          {" "}
                          <Label>Tipo de Cobrança</Label>
                          <FormGroup
                            className={`has-label ${values.tipoCobranca.error}`}
                          >
                            <Input
                              name="tipoCobranca"
                              type="select"
                              onChange={event =>
                                handleChange(event, "tipoCobranca", "text")
                              }
                              onChangeCapture={e => {
                                getCliData(e.target.value);
                              }}
                              value={values.tipoCobranca.value}
                            >
                              <option disabled value="">
                                {" "}
                                Selecione o tipo de cobrança{" "}
                              </option>
                              <option value={1}>Por Hora</option>
                              <option value={2}>Por Projeto</option>
                            </Input>
                            {values.tipoCobranca.error === "has-danger" ? (
                              <Label className="error">
                                {values.tipoCobranca.message}
                              </Label>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <Label>Horas Previstas</Label>
                          <FormGroup
                            className={`has-label ${values.hrsPrevst.error}`}
                          >
                            <Input
                              name="hrsPrevst"
                              type="numeric"
                              onChange={event => {
                                handleChange(event, "hrsPrevst", "number");
                                if (
                                  !(
                                    document.getElementsByName(
                                      "tipoCobranca"
                                    )[0].value === "2"
                                  )
                                ) {
                                  setValues(prevState => ({
                                    ...prevState,
                                    vlrProp: {
                                      value: normalizeCalcCurrency(
                                        JSON.stringify(
                                          event.target.value *
                                            cliRecDespData.valorRec
                                        )
                                      )
                                    }
                                  }));
                                }
                                descontoChange(
                                  document.getElementsByName("vlrDesc")[0].value
                                );
                              }}
                              value={values.hrsPrevst.value}
                            />
                            {values.hrsPrevst.error === "has-danger" ? (
                              <Label className="error">
                                {values.hrsPrevst.message}
                              </Label>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          {" "}
                          <Label>Valor da Proposta</Label>
                          <FormGroup
                            className={`has-label ${values.vlrProp.error}`}
                          >
                            <Input
                              disabled={disabledVlrProp}
                              name="vlrProp"
                              type="numeric"
                              onChange={event => {
                                handleChange(event, "vlrProp", "currency");

                                descontoChange(
                                  document.getElementsByName("vlrDesc")[0].value
                                );
                              }}
                              value={values.vlrProp.value}
                            />
                            {values.vlrProp.error === "has-danger" ? (
                              <Label className="error">
                                {values.vlrProp.message}
                              </Label>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <Label>Valor Desconto</Label>
                          <FormGroup
                            className={`has-label ${values.vlrDesc.error}`}
                          >
                            <Input
                              name="vlrDesc"
                              type="text"
                              onChange={event => {
                                handleChange(event, "vlrDesc", "currency");
                                descontoChange(event.target.value);
                              }}
                              value={values.vlrDesc.value}
                            />
                            {values.vlrDesc.error === "has-danger" ? (
                              <Label className="error">
                                {values.vlrDesc.message}
                              </Label>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          {" "}
                          <Label>Valor Líquido</Label>
                          <FormGroup
                            className={`has-label ${values.vlrLiq.error}`}
                          >
                            <Input
                              disabled
                              name="vlrLiq"
                              type="numeric"
                              onChange={event =>
                                handleChange(event, "vlrLiq", "currency")
                              }
                              value={values.vlrLiq.value}
                            />
                            {values.vlrLiq.error === "has-danger" ? (
                              <Label className="error">
                                {values.vlrLiq.message}
                              </Label>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <Label>Previsão de Lucro</Label>
                          <FormGroup
                            className={`has-label ${values.prevLucro.error}`}
                          >
                            <Input
                              disabled
                              name="prevLucro"
                              type="numeric"
                              onChange={event =>
                                handleChange(event, "prevLucro", "currency")
                              }
                              value={values.prevLucro.value}
                            />
                            {values.prevLucro.error === "has-danger" ? (
                              <Label className="error">
                                {values.prevLucro.message}
                              </Label>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <Label>Número de Parcelas</Label>
                          <FormGroup
                            className={`has-label ${values.numParcelas.error}`}
                          >
                            <Input
                              name="numParcelas"
                              type="select"
                              onChange={event =>
                                handleChange(event, "numParcelas", "text")
                              }
                              value={values.numParcelas.value}
                            >
                              <option disabled value="">
                                {" "}
                                Selecione a quantidade de parcelas{" "}
                              </option>{" "}
                              <option value={1}>01</option>
                              <option value={2}>02</option>
                              <option value={3}>03</option>
                              <option value={4}>04</option>
                              <option value={5}>05</option>
                              <option value={6}>06</option>
                              <option value={7}>07</option>
                              <option value={8}>08</option>
                              <option value={9}>09</option>
                              <option value={10}>10</option>
                              <option value={11}>11</option>
                              <option value={12}>12</option>
                            </Input>
                            {values.numParcelas.error === "has-danger" ? (
                              <Label className="error">
                                {values.numParcelas.message}
                              </Label>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <Label>Motivo Orçamento/Revisão</Label>
                          <FormGroup check>
                            <Label check>
                              <Input
                                defaultChecked={rev !== "true"}
                                name="motivo"
                                type="radio"
                                onChange={event =>
                                  handleChange(event, "motivo", "text")
                                }
                                value={1}
                              />{" "}
                              Orçamento
                            </Label>
                            <Label check>
                              <Input
                                defaultChecked={rev === "true"}
                                name="motivo"
                                type="radio"
                                onChange={event =>
                                  handleChange(event, "motivo", "text")
                                }
                                value={2}
                              />
                              Desconto
                            </Label>
                            <Label check>
                              <Input
                                name="motivo"
                                type="radio"
                                onChange={event =>
                                  handleChange(event, "motivo", "text")
                                }
                                value={3}
                              />
                              Escopo
                            </Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Label>Descrição</Label>
                          <FormGroup
                            className={`has-label ${optional.desc.error}`}
                          >
                            <Input
                              name="desc"
                              type="textarea"
                              onChange={event =>
                                handleChange(event, "desc", "optional")
                              }
                              value={optional.desc.value}
                            />
                            {optional.desc.error === "has-danger" ? (
                              <Label className="error">
                                {optional.desc.message}
                              </Label>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                      <div hidden={isPackageOport}>
                        <Row>
                          <Col md="12">
                            <FileUploadContainer>
                              <UploadFileBtn
                                type="button"
                                onClick={handleUploadBtnClick}
                              >
                                <i className="fas fa-file-upload" />
                                <span>
                                  Arraste e solte ou selecione um arquivo{" "}
                                </span>
                              </UploadFileBtn>
                              <FormField
                                type="file"
                                ref={fileInputField}
                                onChange={handleNewFileUpload}
                                title=""
                                value=""
                              />
                            </FileUploadContainer>
                            <FilePreviewContainer>
                              <PreviewList>
                                {Object.keys(filesAux).map(
                                  (fileName, index) => {
                                    const file = filesAux[fileName];
                                    const isImageFile =
                                      file.type.split("/")[0] === "image";
                                    return (
                                      <PreviewContainer key={fileName}>
                                        <div>
                                          {isImageFile && (
                                            <ImagePreview
                                              src={URL.createObjectURL(file)}
                                              alt={`file preview ${index}`}
                                            />
                                          )}
                                          <FileMetaData
                                            isImageFile={isImageFile}
                                          >
                                            <span>{file.name}</span>
                                            <aside>
                                              {convertBytesToKB(file.size)} kb
                                              <RemoveFileIcon
                                                className="fas fa-trash-alt"
                                                onClick={() =>
                                                  removeFile(fileName)
                                                }
                                              />
                                            </aside>
                                          </FileMetaData>
                                        </div>
                                      </PreviewContainer>
                                    );
                                  }
                                )}
                              </PreviewList>
                            </FilePreviewContainer>
                          </Col>
                        </Row>{" "}
                        <Row>
                          <Col md="4">
                            <Label>Email Principal</Label>
                            <Input disabled value={values.email.value} />
                          </Col>
                          <Col md="8">
                            <Label style={{ display: "block" }}>
                              Bcc Email
                            </Label>
                            <TagsInput
                              onChange={handleTagsinput}
                              tagProps={{
                                className: "react-tagsinput-tag "
                              }}
                              value={tagsinput}
                            />
                          </Col>
                        </Row>
                      </div>
                      <Link to="/tabelas/oportunidade/oport">
                        <Button
                          style={{
                            paddingLeft: 32,
                            paddingRight: 33
                          }}
                          color="secundary"
                          size="small"
                          className="form"
                        >
                          <i
                            className="tim-icons icon-double-left"
                            style={{
                              paddingBottom: 4,
                              paddingRight: 1
                            }}
                            size="large"
                          />{" "}
                          Voltar
                        </Button>
                      </Link>
                      <Button
                        style={{
                          paddingLeft: 29,
                          paddingRight: 30
                        }}
                        className="form"
                        color="info"
                        type="submit"
                      >
                        Enviar{" "}
                        <i
                          className="tim-icons icon-send"
                          style={{
                            paddingBottom: 4,
                            paddingLeft: 3
                          }}
                          size="large"
                        />
                      </Button>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  );
}
